import { CheckCircleIcon } from "@chakra-ui/icons"
import { Box, Heading, Link, Text } from "@chakra-ui/react"

export interface RepoI {
  git: string
  description: string
  icon: any
  color: string
}

export const RepositoryComponent = (props: RepoI) => {
  const { git, description, icon, color } = props

  return (
    <Box
      as={Link}
      href={description}
      textAlign="center"
      py={10}
      px={6}
      cursor={"pointer"}
      target={"_blank"}
    >
      <CheckCircleIcon as={icon} boxSize={"50px"} color={color} />
      {/* <Heading as="h2" size="xl" mt={6} mb={2}>
        {git}
      </Heading> */}
      <Text color={"gray.500"}>{description}</Text>
    </Box>
  )
}
